const childrenLoaded = require('@alexspirgel/children-loaded');
import AccordionJs from 'accordion-js';

class EnhancedAccordion extends HTMLElement {

    constructor() {
        super();
    }

    async connectedCallback() {
        await childrenLoaded(this);
        const accordionContainer = this.querySelector('.acf-innerblocks-container');
        const openedElements = Array.from(accordionContainer.querySelectorAll('[data-is-expanded = "true"]').keys());
        new AccordionJs(accordionContainer, {
            openOnInit: openedElements,
            showMultiple: true,
        });

        // iOS WebKit clips the last line of expanded panels because accordion-js's
        // transitionend → height:auto handoff is unreliable on iOS. Force the
        // handoff after the lib's default 600ms transition + buffer.
        accordionContainer.addEventListener('click', (event) => {
            if (!event.target.closest('.ac-trigger')) return;
            setTimeout(() => {
                accordionContainer.querySelectorAll('.ac.is-active > .ac-panel').forEach((panel) => {
                    if (panel.style.height && panel.style.height !== 'auto') {
                        panel.style.height = 'auto';
                    }
                });
            }, 700);
        });

        // Get the hover color from the accordion
        const hoverColorClass = this.className.match(/enhanced-accordion--hover-([\w-]+)/);
        const hoverColor = hoverColorClass ? hoverColorClass[1] : 'mills-red';

        // PMC Color palette mapping - matching Image Gallery Item implementation
        const colorMapping = {
            'pmc-orange': '#E0604B',
            'rich-black': '#000000',
            'pmc-deep-gray': '#313131',
            'pmc-silver': '#B2B4B6',
            'pmc-light-gray': '#F0F0F0',
            'white': '#FFFFFF',
            'mills-red': '#A41E34',
            'veridian-green': '#40826D',
            'veridian-green-dark': '#255447',
            'veridian-green-light': '#BCE8E0',
            'riverwalk-blue': '#0777BD',
            'riverwalk-dark-blue': '#0E65A0',
            'riverwalk-light-blue': '#2CAAE2',
            'color-guide-dark': '#004D64',
            'color-guide-deep': '#000021',
            'color-guide-gold': '#C3996B',
            // Legacy support
            'red': '#A41E34',
            'palmetto-gray': '#313131',
            'green': '#40826D',
            'black': '#000000'
        };

        // Apply theme color when gallery items within accordion are clicked
        const galleryElements = this.querySelectorAll('.enhanced-accordion-item__content-inner a');
        galleryElements.forEach(element => {
            element.addEventListener('click', () => {
                // Set the gallery theme on body when lightgallery opens
                setTimeout(() => {
                    document.body.setAttribute('data-gallery-theme', hoverColor);
                    // Set CSS variable with the correct color value
                    const colorValue = colorMapping[hoverColor] || '#A41E34';
                    document.documentElement.style.setProperty('--gallery-theme-color', colorValue);
                }, 100);
            });
        });
        
        // Listen for gallery close event to clean up
        document.addEventListener('lgAfterClose', () => {
            document.body.removeAttribute('data-gallery-theme');
            document.documentElement.style.removeProperty('--gallery-theme-color');
        });
    }

}

customElements.define('x-enhanced-accordion', EnhancedAccordion, {extends: 'section'});